export interface PublishingClearDigitalShoPanelProps {
  onClose: VoidFunction;
  disabled?: boolean;
}

export interface ClearDigitalShoAuthenticationResponse {
  isAuthenticated: boolean;
}

export interface ClearDigitalShoPlaylist {
  id: string;
  name: string;
}

export interface ClearDigitalShoUpsertInitialResponse {
  key: string;
}

export interface ClearDigitalShoPollingResponse {
  isAvailable: boolean;
  data: {
    success?: boolean;
  };
}

export enum ClearDigitalShoPanelProgressState {
  STEP_CONNECT = 'STEP_CONNECT',
  STEP_AUTH = 'STEP_AUTH',
  STEP_LOADING = 'STEP_LOADING',
  STEP_PUBLISH = 'STEP_PUBLISH',
  STEP_UNLINKED = 'STEP_UNLINKED',
}

export enum ClearDigitalShoOAuthEvent {
  SUCCESS = 'clear-digital-sho:auth-success',
  ERROR = 'clear-digital-sho:auth-error',
}

export const clearDigitalShoBroadcastChannelName = 'clear-digital-sho-broadcast-channel';
